import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getDropdownHistoryNotifications, getCurrentHistoryNotificationById } from 'redux/notifications/actions';
import { lastNotificationUpdated } from 'constants/storageKeys';
import { IDropdownNotificationsProps } from '../DropdownNotifications';

const withDropdownNotificationsLogic = (Component: React.FC<IDropdownNotificationsProps>) => () => {
  const [isNotificationRead, setIsNotificationRead] = useState<boolean>(true);

  const { 
    sellerId,
    registrationSteps,
    params, 
    notificationsHistory, 
    notificationsHistoryError,
    currentNotification,
    language
  } = useAppSelector(({ sellers, users, notifications, appOptions }) => ({
    sellerId: sellers.currentSeller.info.data?.id,
    registrationSteps: users.currentUser.registrationSteps,
    params: notifications.notificationsHistory.dropdown.params,
    notificationsHistory: notifications.notificationsHistory.dropdown.data,
    notificationsHistoryError: notifications.notificationsHistory.dropdown.error,
    currentNotification: notifications.notificationsHistory.current,
    language: appOptions.language.current
  }))

  const dispatch = useAppDispatch();
  
  useEffect(() => {
    if(sellerId) {
      getPermanentNotifications(sellerId);
      const getNotificationsInterval = setInterval(() => {
        getPermanentNotifications(sellerId)
      }, 1000 * 20);

      return () => clearInterval(getNotificationsInterval);
    }
  }, [sellerId, dispatch, params]);

  const getPermanentNotifications = (sellerId: number) => {
    dispatch(getDropdownHistoryNotifications({
      ...params,
      seller: sellerId,
      locale: language.slice(0,2)
    }) as any);
  }

  useEffect(() => {
    const lastNotificationIdFromStorage = Cookies.get(lastNotificationUpdated);

    if(!lastNotificationIdFromStorage && notificationsHistory && notificationsHistory?.length > 0) {
      Cookies.set(lastNotificationUpdated, JSON.stringify(notificationsHistory[0].updatedAt));
      setIsNotificationRead(false);

    } else if(lastNotificationIdFromStorage && notificationsHistory && notificationsHistory?.length > 0) {

      const lastNotificationUpdatedAtFromStore: string = notificationsHistory[0].updatedAt;

      if(JSON.parse(lastNotificationIdFromStorage) !== lastNotificationUpdatedAtFromStore) {
        setIsNotificationRead(false);
      }
    }
  }, [notificationsHistory])

  const updateNotificationReadStatus = () => {
    if(notificationsHistory && notificationsHistory?.length > 0) {
      if(!isNotificationRead) {
        Cookies.set(lastNotificationUpdated, JSON.stringify(notificationsHistory[0].updatedAt));
        setIsNotificationRead(true);
      }
    }
  }

  const getCurrentNotificationHanlder = (id: number) => {
      dispatch(getCurrentHistoryNotificationById(id) as any);
  }

  return (
    <Component
      notifications={notificationsHistory}
      error={notificationsHistoryError}
      isNotificationRead={isNotificationRead}
      updateNotificationReadStatus={updateNotificationReadStatus}
      registrationSteps={registrationSteps}
      getCurrentNotificationHanlder={getCurrentNotificationHanlder}
      currentNotification={currentNotification}
      sellerId={sellerId}
    />
  )
}

export default withDropdownNotificationsLogic;